import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
// import { useIntl, history, useModel } from 'umi';

export type BreadcrumbProps = {
  items?: any;
  marginBottom?: number;
};

const Breadcrumb: React.FC<BreadcrumbProps> = (props: any) => {
  const { items = [], marginBottom = 16 } = props;

  const navigate = useNavigate();

  return (
    <>
      {items && items.length !== 0 && (
        <>
          <div className={styles.wrapper} style={{ marginBottom }}>
            {items.map((item: any, index: number) => (
              <div className={styles.item} key={index}>
                {index !== 0 && (
                  <div style={{ marginLeft: 8, marginRight: 8 }}>
                    /
                  </div>
                )}
                {index !== items.length - 1 ? (
                  <div
                    className={styles.itemParent}
                    onClick={() => {
                      navigate(item.path);
                    }}
                  >
                    {item.text}
                  </div>
                ) : (
                  <div className={styles.itemLast}>{item.text}</div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};
export default Breadcrumb;
